var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elr-col-full tab-section-header"},[_c('SectionSubheading',[_vm._v("All My Little Ponies")]),_c('SectionHeading',[_vm._v("All Generations")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }